import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Blog', path: '/blog' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-sticky" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_infinity-gta-repair/artifacts/382cgbmn_WhatsApp%20Image%202026-03-04%20at%2012.45.59.jpeg" 
              alt="Infinity Appliances Repair Logo"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`font-medium transition-colors duration-200 hover:text-[#FF6B00] ${
                  isActive(link.path) ? 'text-[#FF6B00] font-semibold' : 'text-[#475569]'
                }`}
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <a
              href="tel:647-919-6893"
              className="pulse-cta flex items-center gap-2 px-5 py-3 rounded-full font-semibold text-white transition-transform hover:scale-105"
              style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
              data-testid="header-call-button"
            >
              <Phone size={18} />
              <span className="hidden sm:inline">647-919-6893</span>
              <span className="sm:hidden">Call</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-button"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100" data-testid="mobile-menu">
            <nav className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
                  className={`px-4 py-3 rounded-lg font-medium transition-colors ${
                    isActive(link.path) 
                      ? 'bg-[#FF6B00]/10 text-[#FF6B00]' 
                      : 'text-[#475569] hover:bg-gray-50'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
